import { IIndirectTaxFilingV2 } from '@commenda/api/indirect-tax/filings';

import { EmptyStateV2 } from '../../../components/empty-state/EmptyStateV2';
import { IndirectTaxFilingDetailReturnSummary } from '../detail/IndirectTaxFilingDetailReturnSummary';
import { IndirectTaxFilingReturnSummaryHelper } from '../helpers';
import type { ContributionLiabilityReportTableRow } from '../types';

/**
 * Stub filing for VAT summary helper — only `contributions` are read; the filing
 * object is unused at runtime.
 */
const VAT_RETURN_SUMMARY_FILING_STUB = {} as IIndirectTaxFilingV2;

interface ContributionLiabilityExpandedContentProps {
  row: ContributionLiabilityReportTableRow;
}

/** Expanded VAT contribution summary for the contribution-backed liability tab. */
export function ContributionLiabilityExpandedContent({
  row,
}: ContributionLiabilityExpandedContentProps) {
  const hasContributionLines =
    Array.isArray(row.contributions) && row.contributions.length > 0;

  return (
    <div className="bg-bg-primary pl-3xl py-xl max-w-[500px]">
      {!hasContributionLines ? (
        <EmptyStateV2
          title="No contribution data"
          description="Contribution lines have not been generated for this filing yet."
          className="min-h-[160px]"
        />
      ) : (
        <IndirectTaxFilingDetailReturnSummary
          summary={IndirectTaxFilingReturnSummaryHelper.buildReturnSummaryForVAT(
            VAT_RETURN_SUMMARY_FILING_STUB,
            row.contributions ?? [],
            row.currency
          )}
        />
      )}
    </div>
  );
}
